import { Box, Divider, Typography } from '@mui/material'
import React from 'react'
import LargeCard from '../../../Shared-ui/SharedComponents/Cards/LargeCard'
import variables from "../../../assets/styles/variables.module.scss"

const UserSubscription = () => {
    return (<>
        <Typography variant="h6">Subscription</Typography>
        <Typography variant="body2">
            View your subscription here.
        </Typography>
        <Divider sx={{ my: 2 }} />
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: {
                    xl: "1fr 1fr 1fr 1fr",
                    lg: "1fr 1fr 1fr 1fr",
                    md: "1fr 1fr",
                },
                gap: 2,
                gridAutoRows: "1fr",
                mt: 3,
            }}
        >
            <Box>
                <LargeCard
                    amount={0}
                    duration="month"
                    title="Basic"
                    summary={["1 Chatbot", "Up to 10M upload characters", "Access to GPT-4o mini AI model", "2 Data sources"]}
                    body={["$25 Billed Monthly", "Includes 1 Team Member"]}
                    color={variables.basicColor} 
                    action="Your current plan"
                />
            </Box>
            <Box>
                <LargeCard
                    amount={20}
                    duration="month"
                    title="Starter"
                    summary={["3 Chatbot", "Up to 50M upload characters", "Use your own LLM  API Keys", "5 Data sources", "Integrations"]}
                    body={["$25 Billed Monthly", "Includes 1 Team Member"]}
                    color={variables.starterColor} 
                    action="Select This Plan"
                />
            </Box>
            <Box>
                <LargeCard
                    amount={499}
                    duration="month"
                    title="Professional"
                    summary={["1 Chatbot", "Up to 10M upload characters", "Access to GPT-4o mini AI model", "2 Data sources"]}
                    body={["$25 Billed Monthly", "Includes 1 Team Member"]}
                    color={variables.professionalColor} 
                    action="Select This Plan"
                />
            </Box>
            <Box>
                <LargeCard
                    amount="Custom Pricing"
                    //duration="month"
                    title="Enterprise"
                    summary={["1 Chatbot", "Up to 10M upload characters", "Access to GPT-4o mini AI model", "2 Data sources"]}
                    body={["$25 Billed Monthly", "Includes 1 Team Member"]}
                    color={variables.enterpriseColor} 
                    action="Select This Plan"
                />
            </Box>
        </Box>
    </>
    )
}

export default UserSubscription